import React from 'react'
import HeaderMain from '../../../Compoents/HeaderMain';
import BreadcrumbArea from '../../../ShearOne/BreadcrumbArea';
import FooterWhite from '../../../Compoents/FooterWhite';
import { Link } from 'react-router-dom';


export const PMCFSolution = () => {
    const breadcrumbLinks = [
        { path: '/', label: 'Home' },
        { label: 'PMCF Solution', active: true }
      ];
      return (
        <>
        <HeaderMain/>
        <main>
       
       <BreadcrumbArea 
         title="PMCF Solution" 
         backgroundImage="/assets/imgs/breadcrumb/page-header-1.png" 
         links={breadcrumbLinks} 
       />
<section class="service-details section-space">
    <div class="container">
        <div class="row flex-xl-row flex-column-reverse">
            <div class="col-xl-4">
                <div class="sidebar sidebar-rr-sticky">
                    <div class="sidebar__widget-service mb-30">
                        <Link to="/service">Medical Device Manufacturers <i class="fa-solid fa-plus"></i></Link>
                        <Link to="/pharmaceutical-details">Pharmaceutical & Biotech industry <i class="fa-solid fa-plus"></i></Link>
                        <Link to="/healthcare-details">Healthcare Providers <i class="fa-solid fa-plus"></i></Link>
                    </div>
                    <div class="sidebar__widget-contact__service text-center">
                        <h4 class="mb-25 title-animation text-capitalize">Are You ready to contact with us</h4>
                        <p class="mb-20"><a href="tel:+86 19811976744"><i class="fa-solid fa-phone"></i>(+86) 19811976744</a></p>
                        <Link to="/contact-us#" class="rr-btn">
                            <span class="btn-wrap">
                                <span class="text-one">Contact Us <i class="fa-solid fa-plus"></i></span>
                                <span class="text-two">Contact Us <i class="fa-solid fa-plus"></i></span>
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
            <div class="col-xl-8">
                <div class="service-details__content">
                    <div class="service-details__content-media mb-20">
                        <img src="./assets/imgs/service-details/service-details-1.jpg" class="img-fluid" alt="img not found"/>
                    </div>
                    <h2 class="title-animation mb-20">Post-Market Clinical Follow-up (PMCF) Solution</h2>
                    <p class="mb-20">PMCF solutions involve ongoing monitoring of medical devices after their market release to ensure continued safety and efficacy. These solutions include systematic data collection, analysis of adverse events, and performance metrics to enhance patient safety and regulatory compliance.</p>
                    <h3 class="title-animation mb-10">How SQUARE MEDTECH Can Support in PMCF Solutions</h3>
                    <p class="mb-30">Our team supports you by drafting PMCF survey plans, designing questionnaires, deploying surveys electronically, and analyzing the collected data. We ensure compliance through statistical analysis and reporting, streamlining regulatory submissions.</p>
                    <ul class="mb-40">
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Development of survey plan</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Creation of questionnaires</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Survey scoping</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Identification of endpoints and acceptance criteria</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Feasibility assessment</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Sample size calculations & statistical justification</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Electronic survey delivery</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Data analysis & reporting</h5></li>
                        <li><span><i class="fa-solid fa-check"></i></span> <h5>Support in communication with the Notified Body</h5></li>
                    </ul>
                    <h3 class="title-animation mb-10">Survey Process</h3>
                    <p class="mb-30">The survey questionnaire is filled out by end-users based on patient charts. It follows a structured PMCF survey plan with clear objectives, statistical justification, and a robust data collection and analysis methodology.</p>
                    <div class="row">
                        <div class="col-lg-7">
                            <div class="service-details__content-media-item">
                                <div class="service-details__content-media-item_img mb-10">
                                    <img src="./assets/imgs/service-details/service-details-2.jpg" class="img-fluid" alt="img not found"/>
                                </div>
                                <h4 class="title-animation mb-15">Data Management Consultancy</h4>
                                <p>We offer expert guidance on optimizing data collection, integration, and analysis to ensure accurate and actionable insights, supporting efficient decision-making throughout research.</p>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <div class="service-details__content-media-item">
                                <div class="service-details__content-media-item_img mb-10">
                                    <img src="./assets/imgs/service-details/service-details-3.jpg" class="img-fluid" alt="img not found"/>
                                </div>
                                <h4 class="title-animation mb-15">Our Expertise in PMCF Solutions</h4>
                                <p>Our multidisciplinary team ensures regulatory compliance, efficient clinical research, and effective survey execution for Post-Market Clinical Follow-up.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


       
    </main>


    <section class="footer__cta footer__cta-bottom-up">
    <div class="container">
        <div class="row mb-minus-30">
            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-primary d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-1.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Medical Writing Services</h4>
                      <ul class="color-white mb-0">
                        <li>Survey Plan</li>
                        <li>Survey Scoping</li>
                        <li>Feasibility Assessment</li>
                      </ul>

                    </div>
                </div>
            </div>

            <div class="col-md-6">
                <div class="footer__cta-item mb-30 theme-bg-glow d-flex flex-lg-row flex-column align-items-lg-center">
                    <div class="footer__cta-item-icon d-flex align-items-center justify-content-center">
                        <img class="img-fluid" src="/assets/imgs/footer__cta/footer__cta-item-2.png" alt="icon not found"/>
                    </div>

                    <div class="footer__cta-item-text">
                    <h4 class="color-white mb-15 mb-10">Our Medical Writing Services</h4>
                  <ul class="color-white mb-0">
                      <li>Questionnaires Creation</li>
                      <li>Electronic Survey Delivery</li>
                      <li>Data Analysis and Reporting</li>
                  </ul>

                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
    <FooterWhite/>

    </>
  )
}
